import list from './list'
import viewList from './view-list'


export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    list.state,
    viewList.state
  ),
  mutations: Object.assign(
    list.mutations,
    viewList.mutations
  )
}



// WEBPACK FOOTER //
// ./src/store/discount-codes/index.js